export default __webpack_public_path__ + "static/media/honor-sharif.b23dc4fc.png";